
export default {
  submitText: '提交',
  submitBtn: false,
  emptyBtn: false,
  labelWidth: 120,
  column: [],
  group: [
    {
        column: [
          {
            label: "项目名称",
            prop: "projectId",
            cascaderItem: ['userIds'],
            disabled:true,
            type: 'tree',
            dicUrl: '/api/v4ward/project/getProjectList',
            props: {label: 'name', value: 'id'},
          },
          {
            label: "计划名称",
            prop: "name",
            disabled:true,
          },

          {
            label: "合格比例(%)",
            prop: "criterionScore",
            disabled:true,
          },
          {
            label: "计算类型",
            prop: "calculateType",
            type: 'select',
            dataType: 'number',
            disabled:true,
            dicUrl: 'api/blade-system/dict/dictionary?code=calculate_type',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: "考核班组",
            prop: "groupName",
            disabled:true,
          },
          {
            label: "考核对象",
            prop: "serviceType",
            type: "select",
            dataType: 'string',
            dicData:[],
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            disabled:true
          },
          {
            label: "考核人员",
            prop: "userIds",
            type: "tree",
            multiple:true,
            disabled:true,
            dicUrl: '/api/v4ward/user/project-user-list?projectId={{projectId}}',
            props: { label: 'realName', value: 'id' },
          },
          {
            label: "通知方式",
            prop: "systemNotifyWays",
            formslot: true,
            disabled:true
          },
          {
            label: "关联合同",
            prop: "contractId",
            type: "tree",
            dataType: 'string',
            dicData: [],
            props: {
              label: "contractName",
              value: "contractId",
            },
            disabled:true
          },
          {
            prop: 'test',
            label: '考核内容',
            formslot: true,
            labelslot: true,
            span: 24,
            row:true,
          },
        ]
    },
  ],
};
